// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

body {
  font-family: Arial, sans-serif;
  line-height: 1.8;
  padding-left: 6px;
  margin-right: 0px !important;
  padding-right: 0px !important;
}

.header {
  font-size: 2rem;
  color: #4caf50;
  margin-bottom: 20px;
}

.container {
  max-width: 1600px;
  max-height: auto;
}

.grpContainer {
  background-color: #f5f5f5;
  border-radius: 0px;
}

.image-container {
  position: relative;
  width: 100%; /* Makes container take full width */
  max-width: 800px; /* Optional: Set a max width */
  margin: auto; /* Centers the container */
}

.image-container img {
  width: 100%; /* Makes image responsive */
  height: auto; /* Maintains aspect ratio */
  display: block;
}

.overlay-text {
  position: absolute;
  top: 65%;
  left: 20%;
  transform: translate(-50%, -50%);
  color: black;
  background: rgb(229, 255, 0);
  padding: 5px 5px;
  font-size: clamp(16px, 3vw, 24px); /* Responsive font size */
  font-weight: bold;
  border-radius: 3px;
  text-align: center;
  white-space: nowrap;
}
.overlay-text1 {
  position: absolute;
  top: 82%;
  left: 20%;
  transform: translate(-50%, -50%);
  color: black;
  background: rgb(77, 255, 0);
  padding: 5px 5px;
  font-size: clamp(16px, 3vw, 24px); /* Responsive font size */
  font-weight: bold;
  border-radius: 3px;
  text-align: center;
  white-space: nowrap;
}

.menulink {
  text-decoration: none;
  color: green;
}

.menulink:hover {
  text-decoration: underline;
  color: green;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW,EAAE,oCAAoC;EACjD,gBAAgB,EAAE,8BAA8B;EAChD,YAAY,EAAE,0BAA0B;AAC1C;;AAEA;EACE,WAAW,EAAE,2BAA2B;EACxC,YAAY,EAAE,2BAA2B;EACzC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,iCAAiC,EAAE,yBAAyB;EAC5D,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,2BAA2B;EAC3B,gBAAgB;EAChB,iCAAiC,EAAE,yBAAyB;EAC5D,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd","sourcesContent":[".App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #282c34;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: white;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\nbody {\r\n  font-family: Arial, sans-serif;\r\n  line-height: 1.8;\r\n  padding-left: 6px;\r\n  margin-right: 0px !important;\r\n  padding-right: 0px !important;\r\n}\r\n\r\n.header {\r\n  font-size: 2rem;\r\n  color: #4caf50;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.container {\r\n  max-width: 1600px;\r\n  max-height: auto;\r\n}\r\n\r\n.grpContainer {\r\n  background-color: #f5f5f5;\r\n  border-radius: 0px;\r\n}\r\n\r\n.image-container {\r\n  position: relative;\r\n  width: 100%; /* Makes container take full width */\r\n  max-width: 800px; /* Optional: Set a max width */\r\n  margin: auto; /* Centers the container */\r\n}\r\n\r\n.image-container img {\r\n  width: 100%; /* Makes image responsive */\r\n  height: auto; /* Maintains aspect ratio */\r\n  display: block;\r\n}\r\n\r\n.overlay-text {\r\n  position: absolute;\r\n  top: 65%;\r\n  left: 20%;\r\n  transform: translate(-50%, -50%);\r\n  color: black;\r\n  background: rgb(229, 255, 0);\r\n  padding: 5px 5px;\r\n  font-size: clamp(16px, 3vw, 24px); /* Responsive font size */\r\n  font-weight: bold;\r\n  border-radius: 3px;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n.overlay-text1 {\r\n  position: absolute;\r\n  top: 82%;\r\n  left: 20%;\r\n  transform: translate(-50%, -50%);\r\n  color: black;\r\n  background: rgb(77, 255, 0);\r\n  padding: 5px 5px;\r\n  font-size: clamp(16px, 3vw, 24px); /* Responsive font size */\r\n  font-weight: bold;\r\n  border-radius: 3px;\r\n  text-align: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n.menulink {\r\n  text-decoration: none;\r\n  color: green;\r\n}\r\n\r\n.menulink:hover {\r\n  text-decoration: underline;\r\n  color: green;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
